import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
import { ReactionView } from './ReactionView';
export var ReactionsList = function ReactionsList(_ref) {
  var reactions = _ref.reactions,
    selectedEmojiId = _ref.selectedEmojiId,
    ProfileCardWrapper = _ref.ProfileCardWrapper;
  return /*#__PURE__*/React.createElement(Box, null, reactions.map(function (reaction) {
    if (reaction.emojiId === selectedEmojiId) {
      return /*#__PURE__*/React.createElement(ReactionView, {
        key: reaction.emojiId,
        reaction: reaction,
        ProfileCardWrapper: ProfileCardWrapper
      });
    } else {
      return null;
    }
  }));
};